import crop_data from "./crop_data";
import crop_data_v2 from "./crop_data_v2";
import agriculture_data from "./agriculture_data";
import worker_housing_data from "./worker_housing_data";
import material_terms_data from "./material_terms_data";
import foreign_labor from "./foreign_labor_data";

const ProfileModalResolver = (tableName) => {
  const modalData = {
    crop: crop_data,
    crop_v2: crop_data_v2,
    agriculture: agriculture_data,
    "worker-housing": worker_housing_data,
    "material-terms": material_terms_data,
    "foreign-labor": foreign_labor,
  };
  return modalData[tableName];
};

export default ProfileModalResolver;
